import {
  faGithub,
  faWhatsapp,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { faMailBulk } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import Fade from 'react-reveal/Fade';
import SocialInfo from '../fakeData/SocialInfo';
import './../index.css';

const Footer = () => {
  return (
    <>
      <Fade bottom cascade>
        <div className='footer-container'>
          <p className='copyRight'>
            &copy; {new Date().getFullYear()} All Rights Reserved to{' '}
            <a
              className='myName'
              href='https://github.com/PriontoAbdullah'
              rel='noopener noreferrer'
              target='_blank'
            >
              Prionto Abdullah
            </a>
          </p>

          <div class='social-media'>
            {SocialInfo?.map((social, index) => (
              <img
                key={social?.id}
                src={social?.icon}
                alt={`${social?.name} icon`}
                className={`w-[32px] h-[32px] object-contain cursor-pointer ${
                  index !== SocialInfo?.length - 1 ? 'sm:mr-6' : 'sm:mr-0'
                }`}
                onClick={() => window.open(social?.link)}
              />
            ))}
          </div>
        </div>
      </Fade>

      {/* This is Side Nav  */}
      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          duration: 1.7,
        }}
      >
        <div className='d-flex flex-column sticky-icon-container'>
          <a
            href='https://wa.me/8801805486757'
            rel='noopener noreferrer'
            target='_blank'
          >
            <FontAwesomeIcon className='sticky-icon' icon={faWhatsapp} />
          </a>
          <a
            href='https://github.com/PriontoAbdullah'
            rel='noopener noreferrer'
            target='_blank'
          >
            <FontAwesomeIcon className='sticky-icon' icon={faGithub} />
          </a>
          <a
            href='https://www.linkedin.com/in/prionto-abdullah/'
            rel='noopener noreferrer'
            target='_blank'
          >
            <FontAwesomeIcon className='sticky-icon' icon={faLinkedin} />
          </a>
          {/* <a
            href='https://prionto71.medium.com/'
            rel='noopener noreferrer'
            target='_blank'
          >
            <FontAwesomeIcon className='sticky-icon' icon={faMedium} />
          </a> */}
          <a
            href={`https://mail.google.com/mail/?view=cm&fs=1&to=prionto71@gmail.com`}
            rel='noopener noreferrer'
            target='_blank'
          >
            <FontAwesomeIcon
              mailto='prionto71@gmail.com'
              className='sticky-icon'
              icon={faMailBulk}
            />
          </a>
          <div className='line' />
        </div>
      </motion.div>
    </>
  );
};

export default Footer;
